import {
  ExploreInsightCondition,
  ExploreInsightDirection,
} from '@toggle/toggle';
import React, { SyntheticEvent } from 'react';

import { InsightIcons } from '../insight-icons/InsightIcons';
import { getInsightIconColorAndDirection } from '../insight-icons/utils';
import * as S from './InsightIconsRoot.styles';

export interface InsightIconsRootProps {
  conditions: ExploreInsightCondition[];
  direction: ExploreInsightDirection;
  isStarred: boolean;
  customSize?: { width: string; height: string };
  isCombined?: boolean;
  isMatched?: boolean;
  layout?: 'vertical' | 'horizontal';
  isSparklesCondensed?: boolean;
  onIconClick?: (e: SyntheticEvent) => void;
}

export const InsightIconsRoot = ({
  conditions,
  direction,
  isStarred,
  customSize,
  isCombined = false,
  isMatched = true,
  layout,
  isSparklesCondensed,
  onIconClick,
}: InsightIconsRootProps) => {
  if (isCombined) {
    const { names, style, iconDirection } = getInsightIconColorAndDirection({
      conditions,
      matched: isMatched,
      direction,
      layout,
    });

    return (
      <S.InsightIconsWrapper
        data-testid="insight-icons-root"
        $disabled={!isMatched}
        onClick={onIconClick}
      >
        {isStarred && (
          <S.StyledImg
            src="/app/static/images/icons/sparkles.svg"
            data-testid="sparkles-svg"
            width={isSparklesCondensed ? 6 : 12}
            height={isSparklesCondensed ? 6 : 12}
          />
        )}
        <InsightIcons
          iconNames={names}
          variant={style}
          direction={iconDirection}
          customSize={customSize}
        />
      </S.InsightIconsWrapper>
    );
  }

  return (
    <>
      {conditions.map((condition, index) => {
        const { names, style, iconDirection } = getInsightIconColorAndDirection(
          {
            conditions,
            matched: isMatched,
            direction,
            layout: undefined,
          }
        );
        return (
          <S.InsightIconsWrapper
            data-testid="insight-icons-root"
            key={`${condition.method}-${index}`}
            onClick={onIconClick}
            $disabled={!isMatched}
          >
            {isStarred && (
              <S.StyledImg
                src="/app/static/images/icons/sparkles.svg"
                data-testid="sparkles-svg"
                width={isSparklesCondensed ? 6 : 12}
                height={isSparklesCondensed ? 6 : 12}
              />
            )}
            <InsightIcons
              iconNames={names}
              variant={style}
              direction={iconDirection}
              customSize={customSize}
            />
          </S.InsightIconsWrapper>
        );
      })}
    </>
  );
};
